export default __webpack_public_path__ + "static/Moodboard-f9295d2d684c33c845cda586af107477.png";